import { useSelector } from 'react-redux'
import { OfferEntry } from '../../../../../types/Controlling/OfferEntry'
import Entry from './Entry'
import props from '../../../../../redux/props'
import Add from './Add'
import { formatEUR } from '../../../../../utility'

type Props = {
  entries: OfferEntry[]
  onChange: (value: OfferEntry[]) => void
}

const Entries: React.FC<Props> = ({ entries, onChange }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const updateEntry = (index: number) => (entry: OfferEntry) => {
    const updatedEntries = entries.map((e, i) => (index === i ? entry : e))
    onChange(updatedEntries)
  }

  const add = (entry: OfferEntry) => onChange([...entries, entry])

  const getTotalSum = () => entries.reduce((acc, e) => acc + e.amount, 0)

  return (
    <div>
      <div className="font-bold">{t.controlling.offer.entry.title}</div>
      <div className="flex flex-col divide-y">
        {entries.map((e, i) => (
          <Entry entry={e} key={e.uuid} onChange={updateEntry(i)} />
        ))}
      </div>
      <div className="mt-2">
        <Add add={add} />
      </div>
      <div>
        {t.controlling.offer.entry.list.totalSum}
        {formatEUR(getTotalSum())}
      </div>
    </div>
  )
}

export default Entries
